import SearchIcon from '@mui/icons-material/Search'
import Box from '@mui/material/Box'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { Kbd } from './Kbd'
import { sidebarRowSx } from './SidebarMenuItem'

const isMac = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.userAgent)

/** Sidebar row that opens a search palette, showing its ⌘K / Ctrl+K shortcut. */
export const SidebarSearchItem = ({ onClick }: { onClick: () => void }) => (
    <ListItemButton
        dense
        onClick={onClick}
        sx={(theme) => ({
            ...sidebarRowSx(theme),
            cursor: 'pointer',
        })}
    >
        <ListItemIcon sx={{ minWidth: '34px', color: 'inherit' }}>
            <SearchIcon />
        </ListItemIcon>
        <ListItemText
            sx={{ paddingLeft: 0 }}
            primary={
                <Box
                    component="span"
                    sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    Search
                    <Box sx={{ opacity: 0.6 }}>
                        {isMac ? (
                            <>
                                <Kbd>⌘</Kbd> + <Kbd>K</Kbd>
                            </>
                        ) : (
                            <>
                                <Kbd>Ctrl</Kbd> + <Kbd>K</Kbd>
                            </>
                        )}
                    </Box>
                </Box>
            }
        />
    </ListItemButton>
)
